import {
  getPaginatedRunInstanceUrl,
  getActiveRunInstanceUrl,
  getRunInstanceDetailUrl,
  runInstanceUrl,
} from "./constants";
import base from "../middlewares/interceptors";
import { getConfig } from "../config/runtimeConfig";

export const getActiveRunInstance = async () => {
  try {
    const response = await base.get(getActiveRunInstanceUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getPaginatedRunInstance = async ({
  page,
  pSize,
  searchTerm,
  signal,
  isActive = "true",
}: any) => {
  try {
    const defaultPage = getConfig("REACT_APP_DEFAULT_PAGE", "1") || 1;
    const defaultPageSize = getConfig("REACT_APP_DEFAULT_PAGE_SIZE", "25") || 25;

    const pageN = page || defaultPage;
    const pageSize = pSize || defaultPageSize;

    const params: { [key: string]: any } = {
      page: pageN,
      size: pageSize,
    };

    // Conditionally add is_active parameter only when it's "true" or "false" (not "all")
    if (isActive && isActive !== "all") {
      params.is_active = isActive;
    }

    // Add search parameter if searchTerm is provided and has minimum 3 characters
    if (searchTerm && searchTerm.trim().length >= 3) {
      params.run_name = searchTerm.trim();
    }

    const response = await base.get(getPaginatedRunInstanceUrl, {
      params,
      signal, // Add abort signal for request cancellation
    });
    return response.data;
  } catch (error) {
    console.error(error);
    // Handle error as needed, you might want to throw it or log it to a monitoring service
    throw error;
  }
};

export const getRunInstanceDetail = async ({ currentRunInstanceId }: any) => {
  try {
    const response = await base.get(
      `${getRunInstanceDetailUrl}/${currentRunInstanceId}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const addRunInstance = async ({ payload }: any) => {
  try {
    const response = await base.post(runInstanceUrl, payload);
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const updateRunInstance = async ({
  currentRunInstanceId,
  payload,
}: any) => {
  try {
    const response = await base.put(
      `${runInstanceUrl}/${currentRunInstanceId}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const deleteRunInstance = async (currentRunInstanceId: number) => {
  try {
    const response = await base.delete(
      `${runInstanceUrl}/${currentRunInstanceId}`
    );
    return { response: response.data, status: response.status };
  } catch (error) {
    console.error(error);
  }
};

/**
 * Reactivate run instance
 * @param runInstanceId - The ID of the run instance to reactivate
 * @returns Promise with reactivation result
 */
export const reactivateRunInstance = async (runInstanceId: string | number) => {
  try {
    const response = await base.put(
      `${runInstanceUrl}/${runInstanceId}/reactivate`
    );
    return response.data;
  } catch (error) {
    console.error("Error reactivating run instance:", error);
    throw error;
  }
};
